import "./select.scss";

const Select = (props) => {
  return (
    <div className={`form-group ${props.label ? "m-1" : ""}`}>
      {props.label && (
        <label htmlFor={props.id}>
          {props.label}{" "}
          {props.required && <span style={{ color: "red" }}>(*)</span>}
        </label>
      )}
      <select
        id={props.id}
        name={props.id}
        value={props.value}
        onChange={props.onChange}
        className={`form-control ${props.className || ""}`}
        style={props.style}
        required={props.required}
      >
        {props.options?.map((opt, idx) => (
          <option key={idx} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
